export const CHECKOUT_DELIVERYOPTIONS = [
  "invoiceAddress",
  "deliveryAddress",
  "newDeliveryAddress"
] as const;

export const INITIAL_ADDRESS_FORM = {
  companyName: "",
  firstName: "",
  lastName: "",
  street1: "",
  street2: "",
  zip: "",
  city: "",
  phone: "",
  country: "DE",
  saveToAddressBook: false
};

/* Below this limit a surcharge is added to the order. */
export const CHECKOUT_SURCHARGE_LIMIT = 100;

export const CHECKOUT_LAST_ORDER_ID_STORAGE_KEY = "hsr.checkout.lastOrderId";
